import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab === 'active') {
            datas.is_active = true
        } else if (data.selectedTab === 'inactive') {
            datas.is_active = false
        }
    }
    return ApiService.get('/user_service/admin-user/role/', datas)
}
export const createApiRecord = data => ApiService.post('/user_service/admin-user/role/', data)
export const getApiRecord = id => ApiService.get(`/user_service/admin-user/role/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/user_service/admin-user/role/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/user_service/admin-user/role/${id}/`)
